import styled from "styled-components";

export const SearchDropdownPerformerCellWrappler = styled.div`
  width: 280px;

  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 20px;

  cursor: pointer;
  user-select: none;
`;

export const SearchDropdownPerformerCellPortrait = styled.img`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
`;

export const SearchDropdownPerformerCellName = styled.div`
  color: var(--tag-tex, #343c46);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
`;
